// The seat's dice palette, told to the server. The server stamps it onto
// every die this seat drops and shows it to the other seat, so both clients
// draw each die (and each initiative d20) in the palette its owner chose.
//
// Announced twice over: when the authoritative Full lands (the match is
// attached, or resumed) if the mirror does not already carry this seat's
// pick, and whenever the pick changes in the tray. The solo pilot announces
// for both seats, since it drops dice from either.
import { setDicePaletteIntent } from '../../../utils/game/net/diceIntents';
import { getDicePalette, onDicePaletteChange } from '../../../utils/game/dice3d/dieAssets';

function seatsOf(host) {
  return host.props?.isCasualSandbox ? ['p1', 'p2'] : [host._localSeat()];
}

/** Tell the server this seat's palette where the mirror does not have it yet. */
export function announceDicePalette(host, mirrorState) {
  const palette = getDicePalette().id;
  for (const seat of seatsOf(host)) {
    if (mirrorState?.players?.[seat]?.dicePalette === palette) continue;
    host._sendMatchIntent(setDicePaletteIntent(palette, seat));
  }
}

/** Follow the tray's pick for as long as the board is up; returns the unsubscribe. */
export function followDicePalette(host) {
  return onDicePaletteChange((palette) => {
    for (const seat of seatsOf(host)) host._sendMatchIntent(setDicePaletteIntent(palette.id, seat));
  });
}
